const countryToggleConfig = countryCode => ({
  hideDepositElanLaw: ['FR'].includes(countryCode),
  moveLandlordPoliciesToPricing: ['BE'].includes(countryCode)
});

export default countryToggleConfig;
